import Reveal from "@/components/Reveal";

const PorQue = () => (
  <section className="relative border-t border-white/10 py-28 md:py-40" data-testid="porque-section">
    <div className="mx-auto max-w-5xl px-6 md:px-12">
      <Reveal>
        <p className="mb-8 text-xs font-medium uppercase tracking-[0.35em] text-neoncyan">
          ¿Por qué elegir este curso?
        </p>
        <h2 className="font-display text-4xl font-black uppercase leading-[0.95] tracking-tighter md:text-6xl">
          Esto no es otro <span className="text-stroke-magenta">curso de marketing</span>
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <p className="mt-12 max-w-3xl text-base leading-relaxed text-lilac/90 md:text-lg">
          Las marcas más grandes del mundo invierten millones en entender cómo sus
          consumidores <span className="font-editorial italic text-magenta">miran, sienten, recuerdan y deciden.</span>{" "}
          Tienen equipos enteros dedicados a leer señales que el consumidor ni sabe que está dando.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-10 max-w-3xl font-editorial text-2xl italic leading-relaxed text-rosewhite md:text-3xl">
          Ese conocimiento existe. Funciona. Y casi ninguna marca pequeña lo usa porque{" "}
          <span className="text-neoncyan">nadie se lo tradujo a su escala.</span>
        </p>
      </Reveal>
      <Reveal delay={0.28}>
        <p className="mt-10 max-w-3xl text-base leading-relaxed text-lilac/90 md:text-lg">
          Este curso te da acceso a esos conceptos, a ese nivel, con un método diseñado para
          que los apliques con las herramientas que ya tenés. Y si trabajás en marketing,
          publicidad o diseño vas a salir con herramientas de neuromarketing y psicología del
          consumidor que la mayoría de los profesionales de tu industria no manejan.
        </p>
      </Reveal>
      <Reveal delay={0.35}>
        <span className="mt-12 block h-px w-24 bg-gradient-to-r from-magenta to-neoncyan" />
      </Reveal>
    </div>
  </section>
);

export default PorQue;
